import { keepPreviousData, useQuery, type UseQueryOptions } from '@tanstack/vue-query';
import { ref, type Ref } from 'vue';
import ApiRequest from '@/plugins/store/actions/api/ApiRequest';
import { Dashboard } from '@/types';

const DEFAULT_OPTIONS: UseQueryOptions<any> = {
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
};

export const queryKeys = {
    getDashboardRoot: ['dashboards', 'hitlist'],
    getDashboard: ({
        scope,
        t,
        isWeaners,
        render,
        locationIds,
        tbFocusBy,
    }: {
        scope: Ref<string>;
        t: Ref<string>;
        isWeaners: Ref<boolean>;
        render: Ref<string>;
        locationIds: Ref<number[]>;
        tbFocusBy: Ref<string | null>;
    }) => [...queryKeys.getDashboardRoot, { scope, t, isWeaners, render, locationIds, tbFocusBy }],
};

export function useHitlistDashboard(
    {
        scope,
        t,
        isWeaners,
        render,
        locationIds,
        tbFocusBy,
    }: {
        scope: Ref<string>;
        t: Ref<string>;
        isWeaners: Ref<boolean>;
        render: Ref<string>;
        locationIds: Ref<number[]>;
        tbFocusBy?: Ref<string | null>;
    },
    options: UseQueryOptions<Dashboard> = {}
) {
    const focusByRef = tbFocusBy ?? ref<string | null>(null);

    return useQuery<Dashboard>({
        queryKey: queryKeys.getDashboard({ scope, t, isWeaners, render, locationIds, tbFocusBy: focusByRef }),
        queryFn: () => {
            let query = `?scope=${scope.value}&t=${t.value}&is_weaners=${isWeaners.value}&render=${render.value}&location_ids=${locationIds.value.join(',')}`;

            if (focusByRef.value) {
                query += `&mode=focus&tb_focus_by=${focusByRef.value}`;
            }

            return new ApiRequest().send('get', `dashboards/hitlist${query}`);
        },
        placeholderData: keepPreviousData,
        ...DEFAULT_OPTIONS,
        ...options,
    });
}
